import { Expose, Type } from 'class-transformer';
import { Model } from '@shared-features/models/model';
import { DispatchActivityEventType } from '@features/shipments/enums/dispatch-activity-event-type.enum';
import { CustomerDispatchStrategy } from '@features/customers/enums/customer-dispatch-strategy.enum';
import { CustomerDispatchRuleScope } from '../enums/customer-dispatch-rule-scope.enum';

export class DispatchEventMetadata {
  @Expose() totalAttempts?: number;
  @Expose() elapsedMs?: number;
  @Expose() nextFleetRank?: number;
}

export class DispatchEvent extends Model {
  @Expose() shipmentId!: number;
  @Expose() eventType!: DispatchActivityEventType;
  @Expose() fleetId?: number;
  @Expose() fleetName?: string;
  @Expose() rank?: number;
  @Expose() responseWindowMinutes?: number;
  @Expose() strategy?: CustomerDispatchStrategy;
  @Expose() ruleScope?: CustomerDispatchRuleScope;
  @Expose() ruleValue?: string;
  @Expose() dispatchRuleId?: number;

  @Expose()
  @Type(() => DispatchEventMetadata)
  metadata?: DispatchEventMetadata;

  @Expose()
  @Type(() => Date)
  createdAt!: Date;
}
